module.exports = "/assets/62849f85c6aa7b0214b70b7ab974ec79.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/SB.png
// module id = 1815
// module chunks = 0